/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Weekly_Hours_UsedInputs */

const en_why_listening_weekly_hours_used = /** @type {(inputs: Why_Listening_Weekly_Hours_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly hours almost used`)
};

const es_why_listening_weekly_hours_used = /** @type {(inputs: Why_Listening_Weekly_Hours_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horas semanales casi agotadas`)
};

/**
* | output |
* | --- |
* | "Weekly hours almost used" |
*
* @param {Why_Listening_Weekly_Hours_UsedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_weekly_hours_used = /** @type {((inputs?: Why_Listening_Weekly_Hours_UsedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Weekly_Hours_UsedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_weekly_hours_used(inputs)
	return en_why_listening_weekly_hours_used(inputs)
});